import { createAction } from '@reduxjs/toolkit'
import { NFT } from 'type/NFT'
import NFTCollection from 'type/NFTCollection'

export const updateNFTCollection = createAction<{ nftCollection: NFTCollection }>('nft/updateNFTCollection')
export const updateNFTList = createAction<{ nftList: NFT[] }>('nft/updateNFTList')
export const updateSelectedNFTs = createAction<{ selectedNFTs: NFT[] }>('nft/updateSelectedNFTs')
export const clearNFTCache = createAction<void>('nft/clearNFTCache')
